var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActPhotoRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 25,
    viewBox: "0 0 13 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "act_photo-right",
    d: "M11.7891 10.4291L1.66782 0.286737C1.28676 -0.0950495 0.668451 -0.0956354 0.286762 0.285321C-0.0950251 0.666278 -0.0956598 1.28459 0.285297 1.66638L10.4073 11.8095C10.7881 12.1902 10.7881 12.8098 10.4066 13.1913L0.285297 23.3336C-0.0956598 23.7154 -0.0950251 24.3337 0.286762 24.7147C0.477338 24.9049 0.726996 25 0.976556 25C1.2268 25 1.47704 24.9044 1.66782 24.7132L11.7884 14.5716C12.9306 13.4293 12.9306 11.5707 11.7891 10.4291Z",
    fill: "#1E3799"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActPhotoRight);
export default __webpack_public_path__ + "static/media/act_photo-right.8e97b693e90e5ea636f9957352662e11.svg";
export { ForwardRef as ReactComponent };